import { IAsinData } from 'modules/sign-up/components/payment-information/payment-information';
import { signUpActionTypes as T } from './action-types';

const postSignUpStep = (actions: any[], onSuccess: () => void, onError: (value: string) => void) => ({
  type: T.POST_SIGN_UP_STEP,
  payload: { actions },
  meta: { onSuccess, onError },
});

const postCompanyInformation = (
  payload: { data: SignUpModule.CompanyInformation; hash: string },
  onSuccess?: () => void,
  onError?: (value: string) => void
) => ({
  type: T.POST_ASIN_INFORMATION,
  payload,
  meta: { onSuccess, onError },
});

const postBusinessInformation = (
  payload: { data: SignUpModule.BusinessInformation; hash: string },
  onSuccess?: () => void,
  onError?: (value: string) => void
) => ({
  type: T.POST_BUSINESS_INFORMATION,
  payload,
  meta: { onSuccess, onError },
});

const postAdditionalInformation = (
  payload: { data: SignUpModule.AdditionalInformation; hash: string },
  onSuccess?: () => void,
  onError?: (value: string) => void
) => ({
  type: T.POST_ADDITIONAL_INFORMATION,
  payload,
  meta: { onSuccess, onError },
});

const postContractTerms = (
  payload: {
    summary_service: boolean;
    terms_and_conditionals: boolean;
    hash: string;
  },
  onSuccess?: () => void,
  onError?: (value: string) => void
) => ({
  type: T.POST_CONTRACT_TERMS,
  payload,
  meta: { onSuccess, onError },
});

const getWallet = (payload: { hash: string }, onComplete: (value: boolean) => void) => ({
  payload,
  type: T.GET_WALLET,
  meta: { onComplete },
});

const createWallet = (payload: { hash: string; card_token_id: string }, onEnd: (value: boolean) => void) => ({
  payload,
  type: T.CREATE_WALLET,
  meta: { onEnd },
});

const postPaymentInformation = (
  payload: { data: SignUpModule.PaymentInformation; hash: string },
  onSuccess?: () => void,
  onError?: (value: string) => void
) => ({
  type: T.POST_PAYMENT_INFORMATION,
  payload,
  meta: { onSuccess, onError },
});

const addUserId = (payload: number) => ({
  type: T.ADD_USER_ID,
  payload,
});

const addSignUrl = (payload: string) => ({
  type: T.ADD_SIGN_URL,
  payload,
});

const addCardData = (payload: { cards: [] }) => ({
  type: T.ADD_CARD_DATA,
  payload,
});

const getUserInfo = (payload: string, onGenerated: () => void, onError: () => void) => ({
  type: T.GET_USER_INFO,
  payload,
  meta: { onGenerated, onError },
});

const setUserInfo = (payload: { first_name: string; last_name: string }) => ({
  type: T.SET_USER_INFO,
  payload,
});

const postDraftFields = (payload: { hash: string; data: Record<string, string> }) => ({
  type: T.POST_DRAFT_FIELDS,
  payload,
});

const completeSingUp = (
  payload: {
    hash: string;
    data: {
      orders?: IAsinData;
      is_brand?: boolean;
      gainz_active?: boolean;
    };
  },
  onError: (value: string) => void,
  onSuccess?: () => void
) => ({
  payload,
  type: T.COMPLETE_SIGN_UP,
  meta: { onError, onSuccess },
});

export const secondSignupStepAction = (
  payload: {
    postCompanyInformation: { data: SignUpModule.CompanyInformation; hash: string };
    postAdditionalInformation: { data: SignUpModule.AdditionalInformation; hash: string };
  },
  onSuccess: () => void,
  onError: (errorMessage: string) => void
) => ({
  type: T.SECOND_SIGNUP_STEP,
  payload,
  meta: { onSuccess, onError },
});

export const firstSignupStepAction = (
  payload: {
    data: SignUpModule.BusinessInformation & { summary_service: boolean; terms_and_conditionals: boolean };
    hash: string;
  },
  onSuccess: () => void,
  onError: (errorMessage: string) => void
) => ({
  type: T.FIRST_SIGNUP_STEP,
  payload,
  meta: { onSuccess, onError },
});

export const signUpActions = {
  postSignUpStep,
  postCompanyInformation,
  postBusinessInformation,
  postAdditionalInformation,
  postContractTerms,
  postPaymentInformation,
  addUserId,
  addSignUrl,
  addCardData,
  getUserInfo,
  setUserInfo,
  getWallet,
  createWallet,
  completeSingUp,
  secondSignupStepAction,
  firstSignupStepAction,
  postDraftFields,
};
